module.exports = __webpack_public_path__ + "zvetseni-prsou_12_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_12_before.jpg
// module id = 1298
// module chunks = 0